import { Validator } from "../validator"

export enum HouseNumberError {
    INVALID = `invalid_input`,
}

const REGEX = /^[a-zA-Z0-9]+$/g
const MAX_LENGTH = 5
class HouseNumberValidator implements Validator<string, HouseNumberError> {
    validate(entry: string): HouseNumberError | undefined {
        if (entry === `` || entry.length > MAX_LENGTH || !entry.match(REGEX)) {
            return HouseNumberError.INVALID
        }
    }
}

export { HouseNumberValidator }